export const ACTIVE_INDEX = 'ACTIVE_INDEX';
export const ARE_USER_PREFERENCE_FETCHED = 'ARE_USER_PREFERENCE_FETCHED';
export const AUTH_MODAL = 'AUTH_MODAL';
export const DELETE_PROFILE_IMAGE = 'DELETE_PROFILE_IMAGE';
export const SET_USER_LOCATION = 'SET_USER_LOCATION'
export const SIGN_OUT = 'SIGN_OUT';
export const TOKEN = 'TOKEN';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_PREFERENCE = 'UPDATE_USER_PREFERENCE';
export const UPDATE_USER_PREFERENCE_BUDGET = 'UPDATE_USER_PREFERENCE_BUDGET';
export const UPDATE_USER_PREFERENCE_FOCUS_AREA = 'UPDATE_USER_PREFERENCE_FOCUS_AREA';
export const UPDATE_USER_PREFERENCE_RELEASED_WITHIN = 'UPDATE_USER_PREFERENCE_RELEASED_WITHIN';
export const USER_DETAILS = 'USER_DETAILS';
export const USER_PREFERENCE_UPDATED = 'USER_PREFERENCE_UPDATED';
export const TRIAL_MODE = 'TRIAL_MODE';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
